// Stores
import type { TMenuSibebar } from '@/stores/TemaStore';

// Router
import { cADMIN_ROUTES } from '@/router/rotasAdmin';

// Shared
import ECodificacao from '@/shared/enums/ECodificacao';

const cMENUS_TEMA_ADMINISTRATIVO: TMenuSibebar[] = [
  {
    id: 'Versoes_TemaAdministrativo',
    titulo: 'Versões',
    icone: 'mdi-gamepad',
    corIcone: '',
    codificacao: ECodificacao.TemaAdministrativo,
    nameRoute: cADMIN_ROUTES.admin.informativoVersoes.name,
  },

  {
    id: 'Conexoes_TemaAdministrativo',
    titulo: 'Conexões',
    icone: 'mdi-connection',
    corIcone: '',
    codificacao: ECodificacao.TemaAdministrativo,
    nameRoute: cADMIN_ROUTES.admin.monitoramentoConexoes.name,
  },

  {
    id: 'Relatorios_TemaAdministrativo',
    titulo: 'Relatórios',
    icone: 'mdi-file-chart',
    corIcone: '',
    nameRoute: cADMIN_ROUTES.admin.relatorio.name,
    codificacao: ECodificacao.TemaAdministrativo,
    children: [
      {
        id: 'HistoricoAcesso_TemaAdministrativo',
        titulo: 'Frequência de Acesso',
        icone: 'mdi-account-clock',
        corIcone: '',
        codificacao: ECodificacao.TemaAdministrativo,
        nameRoute: cADMIN_ROUTES.admin.relatorio.historicoAcesso.name,
      },

      {
        id: 'FrequenciaAtualizacao_TemaAdministrativo',
        titulo: 'Frequência de Atualização',
        icone: 'mdi-file-sync',
        corIcone: '',
        codificacao: ECodificacao.TemaAdministrativo,
        nameRoute: cADMIN_ROUTES.admin.relatorio.frequenciaAtualizacao.name,
      },

      {
        id: 'NecessidadeCargaInicial_TemaAdministrativo',
        titulo: 'Necessidade de Nova Carga Inicial',
        icone: 'mdi-autorenew',
        corIcone: '',
        codificacao: ECodificacao.TemaAdministrativo,
        nameRoute: cADMIN_ROUTES.admin.relatorio.necessidadeNovaCargaInicial.name,
      },

      {
        id: 'TempoDeUsoAplicacao_TemaAdministrativo',
        titulo: 'Tempo de Uso da Aplicação',
        icone: 'mdi-camera-timer',
        corIcone: '',
        codificacao: ECodificacao.TemaAdministrativo,
        nameRoute: cADMIN_ROUTES.admin.relatorio.tempoDeUsoAplicacao.name,
      },

      {
        id: 'RecursosMaisUtilizados_TemaAdministrativo',
        titulo: 'Recursos mais Utilizados',
        icone: 'mdi-monitor-dashboard',
        corIcone: '',
        codificacao: ECodificacao.TemaAdministrativo,
        nameRoute: cADMIN_ROUTES.admin.relatorio.recursosMaisUtilizados.name,
      },

      {
        id: 'ConsumoRecursos_TemaAdministrativo',
        titulo: 'Consumo Recursos',
        icone: 'mdi-cash-multiple',
        corIcone: '',
        codificacao: ECodificacao.TemaAdministrativo,
        nameRoute: cADMIN_ROUTES.admin.relatorio.consumoRecursos.name,
      },
    ],
  },

  {
    id: 'FilaExecucao_TemaAdministrativo',
    titulo: 'Fila de Execução',
    icone: 'mdi-queue-first-in-last-out',
    corIcone: '',
    nameRoute: cADMIN_ROUTES.admin.monitoramentoFila.name,
    codificacao: ECodificacao.TemaAdministrativo,
    children: [
      {
        id: 'Upload_TemaAdministrativo',
        titulo: 'Fila de Upload',
        icone: 'mdi-upload',
        corIcone: '',
        codificacao: ECodificacao.TemaAdministrativo,
        nameRoute: cADMIN_ROUTES.admin.monitoramentoFila.filaUpload.name,
      },
      {
        id: 'Processamento_TemaAdministrativo',
        titulo: 'Fila de Processamento',
        icone: 'mdi-cog',
        corIcone: '',
        codificacao: ECodificacao.TemaAdministrativo,
        nameRoute: cADMIN_ROUTES.admin.monitoramentoFila.filaProcessamento.name,
      },
    ],
  },

  {
    id: 'LogRequisicoes_TemaAdministrativo',
    titulo: 'Log de Requisições',
    icone: 'mdi-api',
    corIcone: '',
    codificacao: ECodificacao.TemaAdministrativo,
    nameRoute: cADMIN_ROUTES.admin.monitoramentoLogRequisicoes.name,
  },

  {
    id: 'HistoricoExecucao_TemaAdministrativo',
    titulo: 'Histórico de Execução',
    icone: 'mdi-clipboard-text-clock-outline',
    corIcone: '',
    codificacao: ECodificacao.TemaAdministrativo,
    nameRoute: cADMIN_ROUTES.admin.monitoramentoHistoricoExecucao.name,
  },

  {
    id: 'PerfilAcesso_TemaAdministrativo',
    titulo: 'Perfil de Acesso',
    icone: 'mdi-table-account',
    corIcone: '',
    codificacao: ECodificacao.TemaAdministrativo,
    nameRoute: cADMIN_ROUTES.admin.perfilAcesso.name,
  },

  {
    id: 'ControleUsuarios_TemaAdministrativo',
    titulo: 'Controle de Usuários',
    icone: 'mdi-account-key',
    corIcone: '',
    codificacao: ECodificacao.TemaAdministrativo,
    nameRoute: cADMIN_ROUTES.admin.controleUsuario.name,
  },

  {
    id: 'Manutencao_TemaAdministrativo',
    titulo: 'Manutenção',
    icone: 'mdi-wrench-clock',
    corIcone: '',
    codificacao: ECodificacao.TemaAdministrativo,
    nameRoute: cADMIN_ROUTES.admin.manutencaoAPI.name,
  },
];

export default cMENUS_TEMA_ADMINISTRATIVO;
